// extracted by mini-css-extract-plugin
module.exports = {"container":"PcPage_container__oKT9w"};